export default __webpack_public_path__ + "static/media/3334 spice rack E side.bf23914a.png";